export enum VatRateState {

  FUTURE = 'FUTURE',
  CURRENT = 'CURRENT',
  EXPIRED = 'EXPIRED',
}
